export enum PreferencesReportTypeEnum {
  event = 'report-event',
  report = 'report',
  path = 'path',
}
